import { EntityAboutCard } from '../EntityAboutCard/EntityAboutCard';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Technology } from '@internal/plugin-pulse-common';
import { Link } from '@backstage/core-components';

export function TechnologyAboutCard() {
  const { entity } = useEntity();
  const spec = (entity?.spec as Technology) ?? {};

  const createExternalLink = (url: string | undefined, label?: string) => {
    if (!url) return undefined;
    return (
      <Link to={url} target="_blank">
        {label || url}
      </Link>
    );
  };

  const fields = {
    Description: spec.description,
    Website: createExternalLink(spec.website),
    Documentation: createExternalLink(spec.documentation),
  };

  return <EntityAboutCard fields={fields} />;
}
